import { JSONNode, toCSS, toJSON } from 'css-convert-json';
import { diff } from 'deep-diff';
import { useEffect, useState } from 'react';
import { useDebouncedCallback } from '../../hooks/useDebouncedCallback';
import { isValidCss } from '../../utils/validator';
import { CodeEditorTextArea } from './CodeEditor/CodeEditorTextArea';

interface Props {
  title?: string;
  value: Record<string, any> | undefined;
  onChange: (value: JSONNode | undefined) => void;
  disabled?: boolean;
  className?: string;
  allowModal?: boolean;
  debounce?: boolean;
}

export const CSSTextArea = ({
  title,
  value,
  onChange,
  disabled,
  className,
  allowModal,
  debounce,
}: Props) => {
  const [buttonCSS, setButtonCSS] = useState<string>('');
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (focused) {
      return;
    }
    setButtonCSS(value ? toCSS(value as any).trim() : '');
  }, [focused, value]);

  const debouncedOnChange = useDebouncedCallback(
    onChange ?? (() => {}),
    debounce ? 1000 : 0,
  );

  return (
    <CodeEditorTextArea
      title={title}
      disabled={disabled}
      className={className}
      value={buttonCSS}
      allowModal={allowModal}
      validation={{
        status: !isValidCss(buttonCSS) ? 'error' : undefined,
        text: !isValidCss(buttonCSS) ? 'Invalid CSS' : undefined,
      }}
      onFocus={() => {
        setFocused(true);
      }}
      onBlur={() => {
        setFocused(false);
      }}
      onChange={(value) => {
        const newButtonCSS = value;
        setButtonCSS(newButtonCSS);
        if (isValidCss(newButtonCSS)) {
          const jsonCss = toJSON(newButtonCSS);
          if (diff(buttonCSS, jsonCss)?.length) {
            debouncedOnChange(toJSON(newButtonCSS));
          }
        }
      }}
    />
  );
};
